import React, { Fragment, useState, useEffect } from 'react';
import { Button, Col, FormGroup, Input, Row } from 'reactstrap';
import { APPConstants } from '../../../../../../constants/app';
import useMaterial from '../../../../../../hooks/useMaterial';
import IconSearch from '../../../../assets/search.svg';
import MaterialList from './MaterialList';

function MaterialSelection({ selectedType, spaceChanged, selectMaterials }) {
    const materialApi = useMaterial();

    const [searchText, setSearchText] = useState('');
    const [materialListShowQty, setMaterialListShowQty] =
        useState(APPConstants.MATERIAL_SELECTION_QUANTITY_STEP);

    const filterMaterialIds = Array.isArray(selectMaterials) ? selectMaterials.map(material => material.materialId) : null;
    const materialsByProjectType = materialApi.materialsByProjectType || [];
    const isFilteredByIds = filterMaterialIds && Array.isArray(filterMaterialIds) && filterMaterialIds?.length > 0
    const hasSelectMaterials = Array.isArray(selectMaterials) && selectMaterials.length > 0;
    let selectedMaterials = {};

    useEffect(() => {
        if (!materialApi.loading) {
            let projectType = selectedType;
            if (!materialApi.error) {
                if (projectType && !materialApi.materialsByProjectType) {
                    materialApi.getByProjectType(projectType.id, true);
                }
            } else {
                console.log(materialApi.error.detail);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedType]);

    const handleSearchTextChange = (event) => {
        setSearchText(event.target.value);
    }

    const handleMaterialListShowQuantity = () => {
        setMaterialListShowQty(
            materialListShowQty + APPConstants.MATERIAL_SELECTION_QUANTITY_STEP
        );
    }

    let idFilteredMaterials = materialsByProjectType;
    if (hasSelectMaterials) {
        // AI mode, in this mode the list provided by AI (selectMaterials) may contain
        // repeated material ID's
        const byProjectTypeIds = materialsByProjectType.map(material => material.id);

        idFilteredMaterials = selectMaterials.filter(material => byProjectTypeIds.includes(material.materialId))
            .map((material, idx) => { 
                const newMaterial = structuredClone(materialsByProjectType.find(materialByType => materialByType.id === material.materialId));
                newMaterial.description = selectMaterials[idx]['ColorFinish'];
                newMaterial.getKey = () => { return newMaterial.id + '_' + newMaterial.description };
                return newMaterial; 
            });
    }

    idFilteredMaterials.forEach((material) => {
        material.key = material.description ? material.getKey() : material.id;
        return material; 
    });

    const filteredMaterials = idFilteredMaterials.filter((material, index) => {        
        if (searchText === '') {
            return index < materialListShowQty;
        } else {
            return material.name.toLowerCase().includes(searchText.toLowerCase())
        }
    });
    
    if (hasSelectMaterials) {

        idFilteredMaterials.forEach(material => {
            let materialPriceList = material.materialPriceLists?.find(priceList => priceList.materialCategory?.id === 1);
            selectedMaterials[material.key] = {
                materialCategoryId: 1,
                currency: materialPriceList?.currency,
                price: materialPriceList?.price,
                name: material.name,
                materialId: material.id.toString(),
                quantity: selectMaterials?.find(
                    selectMaterial => selectMaterial.materialId + '_' + selectMaterial['ColorFinish'] === material.getKey())?.quantity
            }
        });
    }

    return (
        <Fragment>
            {
                !isFilteredByIds &&
                <>
                    <Row className="justify-content-between m-t-65">
                        <Col xs={{ size: 6 }}>
                            <span className="text-label">Select the materials</span>
                        </Col>
                        <Col xs={{ size: 6 }} className="d-flex justify-content-end">
                            {
                                APPConstants.FIX_QUALITY_ENABLE &&
                                <Fragment>
                                    <span className="text-label fix-quality-text">Fix quality</span>
                                    <FormGroup switch>
                                        <Input type="switch" role="switch" />
                                    </FormGroup>
                                </Fragment>
                            }
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={{ size: 12 }}>
                            <FormGroup className="cont-input-search m-b-30">
                                <Input
                                    value={searchText}
                                    className="input-search m-t-12"
                                    placeholder="Search here"
                                    onChange={handleSearchTextChange}
                                />
                                <img src={IconSearch} alt='search' />
                            </FormGroup>
                        </Col>
                    </Row>
                </>
            }
            <Row>
                <Col xs={{ size: 12 }}>
                    <section className="materials-grid">
                        <MaterialList materialsByProjectType={filteredMaterials} spaceChanged={spaceChanged} selectedMaterials={selectedMaterials}/>
                    </section>
                    {
                        (materialListShowQty < idFilteredMaterials.length) &&
                        <div className="d-grid gap-2">
                            <Button
                                color="secondary"
                                size="lg"
                                className="more-materials"
                                onClick={handleMaterialListShowQuantity}
                            >
                                More materials
                            </Button>
                        </div>
                    }
                </Col>
            </Row>
        </Fragment>
    );
}

export default MaterialSelection;